<script lang="ts">
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import Link from "../Link.svelte";
	import type { Image } from "../../../../core/schema/Image";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let path: string;
	export let quantity: number;
	export let size = 128;
	export let image: Image | string;
	export let imgClass = "";
</script>

<div class="relative">
	<Link href={path}>
		{#if typeof image === "string"}
			<StaticPicture alt="Obrázek produktu" height={size} {image} width={size} imgClass="rounded-md {imgClass}" />
		{:else}
			<DynamicPicture
				{image}
				alt={image.title ?? ""}
				bucket="storage"
				height={size}
				imgClass="rounded-md {imgClass}"
				width={size}
			/>
		{/if}
		{#if quantity > 1}
			<span
				class="bg-primary text-2xs absolute bottom-[-.5rem] right-[-.5rem] flex h-4 w-4 items-center justify-center rounded-full p-3 font-semibold text-white md:h-[2rem] md:w-[2rem] md:text-base"
			>
				{quantity}
			</span>
		{/if}
	</Link>
</div>
